import { render, staticRenderFns } from "./StickerSettingButton.vue?vue&type=template&id=06bbcd2c&scoped=true"
import script from "./StickerSettingButton.vue?vue&type=script&lang=ts"
export * from "./StickerSettingButton.vue?vue&type=script&lang=ts"
import style0 from "./StickerSettingButton.vue?vue&type=style&index=0&id=06bbcd2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06bbcd2c",
  null
  
)

export default component.exports